import React, { useState } from "react";
import "./Profile.css";
import "./main.css";
import EditProfileTab from "../Profile/EditProfileTab/EditProfileTab";
import ChangePasswordTab from "../Profile/ChangePasswordTab/ChangePasswordTab";
import MfaSettingsTab from "../Profile/MFASettings/MfaSettingsTab";

const Profile = () => {
  const MenuItem = ["Edit your profile", "Change Password"];
  // const MenuItem = ['Edit your profile', 'Password and authentication', 'MFA Settings'];
  const [selectedItem, setSelectedItem] = useState(0);

  return (
    <div className="profile-container">
      <div className="main-profile-container">
        <div className="profile-main">
          <div>
            <h3>Profile information</h3>
            <h5>These preferences only apply to you.</h5>
          </div>
        </div>
        <div className="routing-profile">
          {MenuItem.map((item, index) => (
            <div
              key={index}
              className={
                index === selectedItem ? "profile-route-item" : "setting-item"
              }
              onClick={() => {
                setSelectedItem(index);

                //gtm
                window.dataLayer.push({
                  event: item,
                  buttonName: item,
                  clientId: JSON.parse(localStorage.getItem("userDetails"))
                    ?.client_id,
                  userId: JSON.parse(localStorage.getItem("userDetails"))?.id,
                });
              }}
            >
              {item}
            </div>
          ))}
        </div>

        <div className="profile-content">
          <div className="profile-tab-bottom"></div>
          {selectedItem === 1 ? (
            <ChangePasswordTab />
          ) : selectedItem === 2 ? (
            <MfaSettingsTab />
          ) : (
            <EditProfileTab />
          )}
        </div>
      </div>
    </div>
  );
};
export default Profile;
